<template>
    <w-form @success="emit('onSemak', form)">
        <w-flex class="ma3" wrap>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">No. Hak Milik :</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    <strong>{{ form.no_hm }}</strong>
                </div>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">No. Hak Milik Asal :</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ form.no_hm_asal }}
                    <w-button
                        :loading="clhm"
                        text
                        class="px0"
                        @click="goToHM(form.no_hm_asal)"
                        v-if="form.no_hm_asal != 'Tiada'"
                    >
                        <w-icon xs>fal fa-share</w-icon>
                    </w-button>
                </div>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">No. Hak Milik Sebelum :</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ form.no_hm_sebelum }}
                    <w-button
                        :loading="clhm"
                        text
                        class="px0"
                        @click="goToHM(form.no_hm_sebelum)"
                        v-if="form.no_hm_sebelum != 'Tiada'"
                    >
                        <w-icon xs>fal fa-share</w-icon>
                    </w-button>
                </div>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">No. Hak Milik Berikut :</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ form.no_hm_berikut }}
                    <w-button
                        :loading="clhm"
                        text
                        class="px0"
                        @click="goToHM(form.no_hm_berikut)"
                        v-if="form.no_hm_berikut != 'Tiada'"
                    >
                        <w-icon xs>fal fa-share</w-icon>
                    </w-button>
                </div>
            </div>

            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">No. Lot :</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.kod_lot }} {{ form.no_lot }}
                </div>
                <w-flex v-if="isEditing">
                    <z-lookup
                        v-if="isEditing"
                        :url="apiBaseUrl + '/jenis-lot'"
                        :sort="false"
                        :cache="false"
                        v-model="form.lkp_hm_lot_id"
                        :placeholder="[[form.kod_lot]]"
                    />
                    <w-input type="text" v-model="form.no_lot"> </w-input>
                </w-flex>
            </div>

            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">No. Akaun :</h5>
                <div class="fw-normal my1 fs-1 mt2">{{ form.no_akaun }}</div>
            </div>

            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Daerah :</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ form.kod_daerah }} - {{ form.daerah }}
                </div>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Mukim :</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ form.kod_mukim }} - {{ form.mukim }}
                </div>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Status Hakmilik :</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                     <span style="color:red;">{{ form.kod_status_hm }} - {{ form.status_hm }}</span>
                </div>
                <z-lookup
                    v-if="isEditing"
                    :url="apiBaseUrl + '/status-hm'"
                    :sort="false"
                    :cache="false"
                    v-model="form.lkp_hm_status_id"
                    :placeholder="[[form.status_hm]]"
                />
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Tarikh Daftar :</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    <div v-if="form.tarikh_daftar != null">
                        {{ moment(form.tarikh_daftar).format("DD/MM/YYYY") }}
                    </div>
                    <div v-else>Tiada Tarikh</div>
                </div>
                <w-input
                    v-if="isEditing"
                    type="date"
                    v-model="form.tarikh_daftar"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Tarikh Batal:</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    <div v-if="form.tarikh_batal != null">
                        {{ moment(form.tarikh_batal).format("DD/MM/YYYY") }}
                    </div>
                    <div v-else>Tiada Tarikh</div>
                </div>
                <w-input
                    v-if="isEditing"
                    type="date"
                    v-model="form.tarikh_batal"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Keluasan :</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{  parseFloat(form.keluasan).toFixed(4)  }} {{ form.unit_keluasan }}
                </div>
                <w-flex v-if="isEditing">
                    <w-input type="text" v-model="form.keluasan"> </w-input>
                    <z-lookup
                        v-if="isEditing"
                        :url="apiBaseUrl + '/unit-keluasan'"
                        :sort="false"
                        :cache="false"
                        v-model="form.lkp_unit_id"
                        :placeholder="[[form.unit_keluasan]]"
                    />
                </w-flex>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Guna Tanah :</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.kod_kegunaan }} - {{ form.kegunaan }}
                </div>
                <z-lookup
                    v-if="isEditing"
                    :url="apiBaseUrl + '/kegunaan-tanah'"
                    :sort="false"
                    :cache="false"
                    v-model="form.lkp_hm_kegunaan_id"
                />
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Halangan:</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                   {{ form.keterangan_halangan ?? "Tidak Berkenaan" }}
                </div>
                <z-lookup
                    v-if="isEditing"
                    :url="apiBaseUrl + '/halangan'"
                    :sort="false"
                    :cache="false"
                    v-model="form.flag_halangan"
                />
            </div>

            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Cukai Semasa(RM):</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.cukai }}
                </div>
                <w-input v-if="isEditing" type="number" v-model="form.cukai">
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Cukai Baru(RM):</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.cukai_baru }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.cukai_baru"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Tarikh Cukai Baru:</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    <div v-if="form.tarikh_aktif_cukai_baru != null">
                        {{
                            moment(form.tarikh_aktif_cukai_baru).format(
                                "DD/MM/YYYY"
                            )
                        }}
                    </div>
                    <div v-else>Tiada Tarikh</div>
                </div>
                <w-input
                    v-if="isEditing"
                    type="date"
                    v-model="form.tarikh_aktif_cukai_baru"
                >
                </w-input>
            </div>

            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Cukai Lama(RM):</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.cukai_lama }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.cukai_lama"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Cukai Parit Tali Air(RM):</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.cukai_parit_tali_air }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.cukai_parit_tali_air"
                >
                </w-input>
            </div>

            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Ampun Hasil :</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ form.is_ampun_hasil }}
                </div>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Pengecualian Aktif :</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ form.is_pengecualian }}
                </div>
            </div>

            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Tempoh Pajak (Tahun):</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.tempoh_pajakan }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.tempoh_pajakan"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Tarikh Luput Pajak:</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    <div v-if="form.tarikh_luput_pajakan != null">
                        {{
                            moment(form.tarikh_luput_pajakan).format(
                                "DD/MM/YYYY"
                            )
                        }}
                    </div>
                    <div v-else>Tiada Tarikh</div>
                </div>

                <w-input
                    v-if="isEditing"
                    type="date"
                    v-model="form.tarikh_luput_pajakan"
                >
                </w-input>
            </div>

            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Mula Ansuran Prem.:</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.tarikh_mula_anspri }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.tarikh_mula_anspri"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Tamat Ansuran Prem.:</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.tarikh_tamat_anspri }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.tarikh_tamat_anspri"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Tempoh Ansuran Prem.:</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.tmp_anspri }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.tmp_anspri"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Ansurans Premium (RM):</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.ans_premium }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.ans_premium"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Jumlah Premium (RM):</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.jumlah_premium }}
                </div>
                <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.jumlah_premium"
                >
                </w-input>
            </div>
            <div class="xs12 sm6 md4 lg3 pa3">
                <h5 class="fw-semibold fs-2">Pengisytiharan Tanah:</h5>
                <div v-if="!isEditing" class="fw-normal my1 fs-1 mt2">
                    {{ form.isytihar_tanah !=null ? form.isytihar_tanah.keterangan : 'Tiada Pengisytiharan' }}
                </div>
                <z-lookup
                    v-if="isEditing"
                    :url="apiBaseUrl + '/lkp-isytihar'"
                    :sort="false"
                    :cache="false"
                    v-model="form.tanah_isytihar"
                />
                <!-- <w-input
                    v-if="isEditing"
                    type="number"
                    v-model="form.jumlah_premium"
                >
                </w-input> -->
            </div>
            <!-- <div class="xs12 sm6 md4 lg3 pa3" v-if="this.cukai.is_petak==1">
                <h5 class="fw-semibold fs-2">Petak Aksesori:</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ this.cukai.petakAksesori.petak }}
                </div>

            </div>
            <div class="xs12 sm6 md4 lg3 pa3" v-if="this.cukai.is_petak==1">
                <h5 class="fw-semibold fs-2">Keluasan Petak Aksesori:</h5>
                <div class="fw-normal my1 fs-1 mt2">
                    {{ this.cukai.petakAksesori.totalKeluasan }}&nbsp;{{ this.cukai.petakAksesori.unit }}
                </div>

            </div> -->

            <!-- <div class="xs2 pa3">
                <h5 class="fw-semibold fs-2">Status Bayaran:</h5>
                <div v-if="form.terimaan.length" class="fw-normal my1 fs-1 mt2">
                      Belum Bayar
                </div>
                <div v-else class="fw-normal my1 fs-1 mt2">
                      Sudah Bayar
                </div>

            </div> -->
        </w-flex>
    </w-form>
    <w-flex v-if="editable">
        <div class="spacer" />
        <w-button
            :loading="loading"
            v-if="!isEditing"
            @click="isEditing = !isEditing"
        >
            Kemaskini
        </w-button>
        <w-button
            :loading="loading"
            v-if="isEditing"
            @click="isEditing = !isEditing"
            text
        >
            Batal
        </w-button>
        <w-button
            :loading="loading"
            v-if="isEditing"
            @click="update()"
            class="ml3"
        >
            Simpan
        </w-button>
    </w-flex>

    <w-dialog
        v-model="dialog"
        title="Makluman"
        persistent
        :width="550"
    >
        No. hakmilik <b>{{ lhm }}</b> tidak wujud di pangkalan data iHasil.
        <br/>
        Anda boleh menggunakan tab <b>'Sejarah Bayaran'</b> untuk menyemak bayaran hakmilik sebelum.

        <template #actions>
            <div class="spacer" />
            <w-button @click="dialog = false" bg-color="success">
                OK
            </w-button>
        </template>
    </w-dialog>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import WaveUI from "wave-ui";
import moment from "moment";
import { Inertia } from "@inertiajs/inertia";
import { usePage } from '@inertiajs/inertia-vue3';

const waveui = new WaveUI();
const apiBaseUrl = process.env.MIX_API_BASE_URL;
const form = ref({});
const props = defineProps({
    cukai: Object,
    editable: {
        type: Boolean,
        default: false,
    },
});
const user_id = usePage().props.value.auth.user.id;

onMounted(() => {
    form.value = props.cukai;
    console.log(form.value);
});

watch(
    () => props.cukai,
    (nv, ov) => {
        form.value = nv;
    }
);

const isEditing = ref(false);
const loading = ref(false);
const clhm =  ref(false);
const lhm =  ref('');
const dialog = ref(false);

async function update() {
    const l = {
        id: form.value.id,
        lkp_hm_status_id: form.value.lkp_hm_status_id,
        tarikh_daftar:form.value.tarikh_daftar,
        lkp_hm_lot_id: form.value.lkp_hm_lot_id,
        no_lot: form.value.no_lot,
        keluasan: form.value.keluasan,
        lkp_unit_id: form.value.lkp_unit_id,
        lkp_hm_kegunaan_id: form.value.lkp_hm_kegunaan_id,
        tempoh_pajakan:form.value.tempoh_pajakan,
        tarikh_luput_pajakan:form.value.tarikh_luput_pajakan,
        // lkp_hm_nyata_id:form.value.lkp_hm_nyata_id,
        cukai:form.value.cukai,
        cukai_baru:form.value.cukai_baru,
        cukai_lama:form.value.cukai_lama,
        cukai_parit_tali_air:form.value.cukai_parit_tali_air,
        tarikh_batal:form.value.tarikh_batal,
        tarikh_aktif_cukai_baru:form.value.tarikh_aktif_cukai_baru,
        ans_premium:form.value.ans_premium,
        tmp_anspri:form.value.tmp_anspri,
        tarikh_mula_anspri:form.value.tarikh_mula_anspri,
        tarikh_tamat_anspri:form.value.tarikh_tamat_anspri,
        jumlah_premium:form.value.jumlah_premium,
        flag_halangan:form.value.flag_halangan,
        isytihar_tanah:form.value.tanah_isytihar,
        user_id:user_id,
    };
    loading.value = true;
    await axios({
        method: "post",
        url: `${apiBaseUrl}/cukai/kemaskini/hak-milik/${form.value.id}`,
        responseType: "json",
        data: l,
    })
        .then((e) => {
            form.value = e.data[0];
            waveui.notify({
                success: true,
                message: "Berjaya! Maklumat hak milik telah dikemaskini.",
                timeout: 3000,
            });
        }).catch(err => {
            //  this.$waveui.notify({
            //     error: true,
            //     message: "Ralat",
            //     timeout: 3000,
            //   });
        }).finally((e) => {
            loading.value = false;
            isEditing.value = false;
        });
}

async function goToHM(e){
    clhm.value = true;
    lhm.value = e
    const l = {
                kategoriCarian: "1",
                formOption: "option1",
                barcode: e,
                kodDaerah: "01",
            };

    await axios({
        method: "post",
        url: `${apiBaseUrl}/cukai/cari`,
        responseType: "json",
        data: l,
    })
    .then((e) => {
        if (e.data.length > 0) {
            const url = window.route(
                "cukai-tanah.butirancukai",
                { no_hm: lhm.value }
            );
            Inertia.get(url,{},{preserveState: false, preserveScroll: true });
        } else {
            // waveui.notify({
            //     info: true,
            //     message: `Hakmilik ${e} tidak wujud di iHasil`,
            //     timeout: 3000,
            // });
            dialog.value = true;
        }
    }).finally(() => {
        clhm.value = false;
    })
}
</script>
<style>
::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(35, 71, 129);
    font-style: normal;
    opacity: 1; /* Firefox */
}
h5.fw-semibold.fs-2 {
    font-family: "Open Sans", Helvetica, Arial;
}
@media only screen and (max-width: 1495px) {
    h5.fw-semibold.fs-2
    {
        line-height: 15px;
    }
}

/* Example CSS for responsiveness */
@media screen and (max-width: 768px) {
    .xs12 {
        width: 100%; /* Take full width on small screens */
    }
    .sm6 {
        width: 50%; /* Half width on small screens */
    }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
    /* Adjust styles for medium-sized screens */
}

@media screen and (min-width: 1025px) {
    /* Adjust styles for large screens */
}


</style>
